import {
  PREFERENCE_EVENT_TYPES,
  type NotificationEventChannelPreference,
  type NotificationPreferences,
} from '../notification-preferences.model';

const DEFAULT_CHANNEL: NotificationEventChannelPreference = {
  email: false,
  inApp: true,
};

function createDefaultEventTypes(): NotificationPreferences['eventTypes'] {
  return Object.fromEntries(
    PREFERENCE_EVENT_TYPES.map((eventType) => [
      eventType,
      { ...DEFAULT_CHANNEL },
    ])
  );
}

/** Canonical mock {@link NotificationPreferences}. */
export const MOCK_NOTIFICATION_PREFERENCES: NotificationPreferences = {
  digestCadence: 'daily',
  emailDigestEnabled: false,
  eventTypes: createDefaultEventTypes(),
  id: 1,
  inAppEnabled: true,
};

/** Builds {@link NotificationPreferences} from {@link MOCK_NOTIFICATION_PREFERENCES}. */
export function createMockNotificationPreferences(
  overrides?: Partial<NotificationPreferences>
): NotificationPreferences {
  return {
    ...MOCK_NOTIFICATION_PREFERENCES,
    ...overrides,
    eventTypes: {
      ...MOCK_NOTIFICATION_PREFERENCES.eventTypes,
      ...overrides?.eventTypes,
    },
  };
}
